exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".divOutline{padding:10px 0px 10px 10px;border-bottom:1px solid lightgrey}.btn-outline{background-color:transparent;border-color:transparent;color:black;box-shadow:none}.btn-outline:disabled{background-color:transparent}.btn-outline:hover{background-color:transparent;color:black;cursor:pointer !important}.btn-text{color:black;margin-right:10px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/HomeElements/BackButton.scss
// module id = 1039
// module chunks = 0